<template>
    <div class="gray-bg">
        <div class="center clearfix">
            <leftNav :selected="leftnav"></leftNav>
            <div class="content">
                <div class="content-title">
                    <h5>认证信息</h5>
                </div>
                <form name="form" class="form"  action="">
                    <h6 class="dataTitle">职业证明 </h6>
                    <table width="100%" class="from-table">
                        <tr>
                            <td width="15%">
                                <label for="certificateType">证件类型</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="certificateType" required v-model="Customer.qualType">
                            </td>
                            <td width="15%">
                               <label for="Grade"> 证件等级</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="Grade" required v-model="Customer.qualLevel">
                            </td>
                        </tr>
                        <tr>
                            <td width="15%">
                                <label for="IDNumber">证件号码</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="IDNumber" required v-model="Customer.qualId">
                            </td>
                            <td width="15%">
                               <label for="available"> 获得日期</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="available" required v-model="Customer.qualTime">
                            </td>
                        </tr>

                        <tr>
                            <td width="15%" rowspan="2">
                                证件照片
                            </td>
                            <td width="35%" class="from-img-box" rowspan="2">
                                <label class="file-label" for="pictures">点击上传证件照片</label>
                                <input autocomplete="off" type="file" accept="image/png, image/jpeg, image/jpg" id="pictures" class="from-file" @change="Picture($event)" required>
                                <label class="img-label" for="pictures">
                                    <img class="from-img2" :src="Pictures"/>
                                </label>
                            </td>
                            <td width="15%" >
                                认证类型
                            </td>
                            <td width="35%">
                                <select class="from-input " required @change="Certification($event)" v-model="Customer.secondType">
                                    <option disabled selected value="">请选择</option>
                                    <option v-for="(item,index) in certificationType" :value="item">{{item}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td width="15%" >
                                <label for="expiry">失效日期</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="expiry" required v-model="Customer.expiredTime">
                            </td>
                        </tr>
                        
                    </table>
                    <h6 class="dataTitle">结算账号 </h6>
                    <table width="100%" class="from-table">
                        <tr>
                            <td width="15%">
                                <label for="accountsName">支付宝姓名</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="accountsName" required v-model="Customer.accountName">
                            </td>
                            <td width="15%">
                               <label for="accountsID"> 支付宝账号</label>
                            </td>
                            <td width="35%">
                                <input type="text" class="from-input" id="accountsID" required v-model="Customer.accountId" >
                            </td>
                        </tr>
                    </table>
                    <h6 class="dataTitle">达人照片 </h6>
                    <p class="dataHint">达人照片请上传一张清晰的个人照片，横板构图，上传图片将作为自己的个人封面。</p>
                    <table width="100%" class="from-table">
                        <tr>
                            <td class="from-img-box">
                                <label class="file-label file-label2" for="expertPicture">点击上传图片</label>
                                <input autocomplete="off" type="file" accept="image/png, image/jpeg, image/jpg" id="expertPicture" class="from-file" @change="ExpertPicture($event)" required>
                                <label class="img-label img-label2" for="expertPicture">
                                    <img class="from-img3" :src="ExpertPictures"/>
                                </label>
                            </td>
                        </tr>
                    </table>
                    <h6 class="dataTitle">简要介绍 </h6>
                    <p class="dataHint">请简要介绍您是一个什么样的人，或者说说您有哪方面的特长等等，让旅客更多的了解您。</p>
                    <table width="100%" class="from-table">
                        <tr>
                            <td >
                                <textarea class="from-textarea" id="signature" rows="8" required v-model="Customer.content"></textarea>
                            </td>
                        </tr>
                    </table>
                    <div class="clearfix"><button class="btn BtnForm" @click="BtnForm">提交</button></div>
                    
                </form>
            </div>
        </div>
        
    </div>
</template>
<script>
import leftNav from '@/components/public/leftNav'
import Headshot from '@/components/public/headshot'
import Site from '@/components/public/site'
import data from '@/assets/css/data.scss'

export default {
    name: 'authentication',
    data () {
        return {
            sendSelected:'',
            colourClass:'white',
            leftnav:'authentication',
            session:'',
            certificationType:[ '位讯达人', '境内导游', ' 全程领队', '境外导游',  '市区包车', '短途包车', '长途包车', '车导服务','护照'],//认证类型
            // certification:'',
            Pictures:'',//证件照片
            PicturesFile:'',//证件照片
            ExpertPictures:'',//达人照片
            ExpertPicturesFile:'',//达人照片
            Customer:{
                qualType:'',//证件类型
                qualLevel:'',//证件等级
                qualId:'',//证件号码
                qualTime:'',//获得日期
                coQualPhoto:'',//证件照片张数
                expiredTime:'',//失效日期
                secondType:'',//认证类型
                accountType:11,//支付类型
                accountName:'',//支付宝姓名
                accountId:'',//支付宝账号
                content:'',//简要介绍
                coImage:'',//达人照片张数
            },
        }
    },
    computed:{
        // 达人认证
        TalentApplyView(){ // 获取达人认证
            return this.$store.state.interface.gwTalentApplyView;
        },
        TalentApply(){ // 提交达人认证
            return this.$store.state.interface.gwTalentApply;
        },
        
        // 供应商
        gwSupplierApplyView(){ // 获取供应商
            return this.$store.state.interface.gwSupplierApplyView;
        },
        gwSupplierApply(){ // 提交供应商
            return this.$store.state.interface.gwSupplierApply;
        },

        fileUpload(){ //图片
            return this.$store.state.interface.fileUpload;
        },
        
    },
    methods:{
		
        Picture(event){ //图片添加
            let file = event.target.files[0],
            reader = new FileReader(),
            formData = new FormData(),
            value = event.target.value,
            self = this;
            if(file){
                if (/^image\/png/.test(file.type) || /^image\/jpeg/.test(file.type)){
                // self.file=file;
                    reader.onload = function(e){ 
                        let result = e.target.result;
                        $(event.target).siblings('.img-label').show().siblings('.file-label').hide();
                        value = '';
                        self.Pictures=result;
                        self.PicturesFile=file; 
                        self.Customer.coQualPhoto=1; 
                        // if(self.imgList.length<1){
                        //     if(self.imgList.indexOf(result) == -1){ 
                        //         self.imgList.push(result);
                        //         value = '';
                        //         self.file=file;
                        //         // console.log(self.imgList)
                        //         // self.thenewproduct.coImage=self.imgList.length;
                        //     }else{// 已存在
                        //         self.$layer.msg('图片已存在！');
                        //     }
                        // }else{
                        //     self.$layer.msg('主图限制9张以内！');
                        // }
                        
                    }

                    reader.readAsDataURL(file);
                // formData.append('file', e.target.files[0]);
                // formData.append('type', 'test');
                }else if(/^image\/gif/.test(file.type)){
                    self.$layer.msg('不支持的图片格式！');
                }else{
                    self.$layer.msg('该文件不是图片！');
                }    
            }else{//没有选
                return;
            }
        },
        Certification(){

        },
        ExpertPicture(event){
            let file = event.target.files[0],
            reader = new FileReader(),
            formData = new FormData(),
            value = event.target.value,
            self = this;
            if(file){
                if (/^image\/png/.test(file.type) || /^image\/jpeg/.test(file.type)){
                // self.file=file;
                    reader.onload = function(e){ 
                        let result = e.target.result;
                        $(event.target).siblings('.img-label').show().siblings('.file-label').hide();
                        value = '';
                        self.ExpertPictures=result;
                        self.ExpertPicturesFile=file; 
                        self.Customer.coImage=1; 
                        // if(self.imgList.length<1){
                        //     if(self.imgList.indexOf(result) == -1){ 
                        //         self.imgList.push(result);
                        //         value = '';
                        //         self.file=file;
                        //         // console.log(self.imgList)
                        //         // self.thenewproduct.coImage=self.imgList.length;
                        //     }else{// 已存在
                        //         self.$layer.msg('图片已存在！');
                        //     }
                        // }else{
                        //     self.$layer.msg('主图限制9张以内！');
                        // }
                        
                    }

                    reader.readAsDataURL(file);

                // formData.append('file', e.target.files[0]);
                // formData.append('type', 'test');
                }else if(/^image\/gif/.test(file.type)){
                    self.$layer.msg('不支持的图片格式！');
                }else{
                    self.$layer.msg('该文件不是图片！');
                }    
            }else{//没有选
                return;
            }
        },
        UrlPath(){
            var Url = window.location.href;
            var UrlPath=Url.split('/');
            for(var i in UrlPath){
                if(UrlPath[i]=='cooperation'){
                    this.sendSelected='cooperation';
                }else if(UrlPath[i]=='league'){
                    this.sendSelected='league';
                    this.certificationType=[ '批发商', '组团社'] 
                }
            }
        },
        BtnForm(){
            var self = this;
            event.preventDefault();

            var Value = false;
            $('.from-input').each(function(){
                if(this.value == ''){
                    Value = false;
                    return;
                }else{
                    Value = true;
                }
            });

            if(self.Customer.coImage == ''){
                Value = false;
                self.$layer.msg('请上传达人照片！');
                return;
            }else if(self.Customer.coQualPhoto == ''){
                Value = false;
                self.$layer.msg('请上传证件照片！');
                return;
            }else if(self.Customer.secondType == ''){
                Value = false;
                self.$layer.msg('请选择认证类型！');
                return;
            }else if(self.Customer.content == ''){
                Value = false;
                self.$layer.msg('请填写简要介绍！');
                return;
            }else{
                Value = true;
            }

            if(Value == false){
                self.$layer.msg('请把信息填写完整！');
                return;
            }

            var sessionId = JSON.parse(this.session).sourceType;
            var id = JSON.parse(this.session).id;
            let config = {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
            }
            // 证书图片提交
            if(self.PicturesFile != ''){
                let formData1 = new FormData();
                    formData1.append('file', this.PicturesFile);
                    formData1.append('coImage', this.Customer.coQualPhoto);
                    formData1.append('sourceType', 'LxTalentCertify');
                    formData1.append('sid', sessionId);
                    formData1.append('sourceId', id);
                    formData1.append('app', 'liexing');
                    formData1.append('platform', 'web');
                    formData1.append('ver', 3);
                
                self.$ajax.post(self.fileUpload,formData1,config).then(function(res2) {
                    if(res2.data.code == '10000' ){
                        self.$layer.msg('证件照片上传成功！');
                        return;
                    }else{
                        self.$layer.msg('证件照片上传失败！');
                    
                    }
                },function(res2) {
                    self.$layer.msg('证件照片上传失败！');
                });
            }
            // 达人照片
            if(self.ExpertPicturesFile != ''){
                let formData2 = new FormData();
                    formData2.append('file', this.ExpertPicturesFile);
                    formData2.append('coImage', this.Customer.coImage);
                    formData2.append('sourceType', 'LxTalent');
                    formData2.append('sid', sessionId);
                    formData2.append('sourceId', id);
                    formData2.append('app', 'liexing');
                    formData2.append('platform', 'web');
                    formData2.append('ver', 3);
                
                self.$ajax.post(self.fileUpload,formData2,config).then(function(res3) {
                    if(res3.data.code == '10000' ){
                        self.$layer.msg('达人照片上传成功！');
                        return;
                    }else{
                        self.$layer.msg('达人照片上传失败！');
                    
                    }
                },function(res3) {
                    self.$layer.msg('达人照片上传失败！');
                });
            }

            let formData = new FormData();
                formData.append('qualType', self.Customer.qualType);
                formData.append('qualLevel', self.Customer.qualLevel);
                formData.append('qualId', self.Customer.qualId);
                formData.append('qualTime', self.Customer.qualTime);
                formData.append('coQualPhoto', self.Customer.coQualPhoto);
                formData.append('expiredTime', self.Customer.expiredTime);
                formData.append('secondType', self.Customer.secondType);
                formData.append('accountType', self.Customer.accountType);
                formData.append('accountName', self.Customer.accountName);
                formData.append('accountId', self.Customer.accountId);
                formData.append('content', self.Customer.content);
                formData.append('coImage', self.Customer.coImage);
                formData.append('app', 'liexing');
                formData.append('platform', 'web');
                formData.append('sid', sessionId);
                

            self.$ajax.post(self.TalentApply,formData).then(function(res) {
                if(res.data.code == '10000' ){
                    self.$router.push({ path: '/cooperation/succeed' })

                }else if(res.data.code == '14001' ){
                    self.$layer.msg('参数错误');
                }else{
                    self.$layer.msg('提交失败');
                }
            },function(res) {
                self.$layer.msg('提交失败');
            });
        }
    },
    beforeMount(){
        var self= this;
        
        this.session=sessionStorage.getItem('GWcustomer');
        var sessionId = JSON.parse(this.session).sourceType;
        if(this.session==null){
            if(self.sendSelected=='cooperation'){
                self.$router.push({ path: '/cooperation' })
            }else if(self.sendSelected=='league'){
                self.$router.push({ path: '/league' })
            }
        }

        this.$ajax.post(this.TalentApplyView+'?sid='+sessionId).then(function(res){
            if(res.data.code == '10000'){
                self.Customer= res.data.result.GwTalent;
                if(self.Customer.bqualImage!=''){
                    self.Pictures=self.Customer.bqualImage;
                    $('#pictures').siblings('.img-label').show().siblings('.file-label').hide();
                }
                if(self.Customer.bcontentImage!=''){
                    self.ExpertPictures=self.Customer.bcontentImage;
                    $('#expertPicture').siblings('.img-label').show().siblings('.file-label').hide();
                }
            }else{
                self.$layer.msg('资料获取失败');
            }
        },function(res){
            self.$layer.msg('资料获取失败');
        })
        
        
        
    
        
    },
     mounted(){
        this.UrlPath() // 路径判断达人还是供应商
        this.$emit('nav',this.sendSelected,this.colourClass);
    },
    components:{
        leftNav,
        Headshot,
        Site,
    },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/cooperation/authentication.vue